import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { IPage, IStore } from '../../modules/storefront/exports/Interfaces';
import { getStorefrontOrigin } from '../../modules/storefront/exports/Cookies';
import DomainResource from '../resources/DomainResource';
import { getHostname } from 'tldts';

class StorefrontManager {
  private readonly BASE_URL = getStorefrontOrigin();

  public getStore = async (): Promise<DataWrappedResponse<IStore>> => {
    if (this.isStorefront()) {
      return BackendApiClient.requestAsync({
        baseURL: this.BASE_URL,
        method: 'GET',
        url: `/api/store`,
      });
    }

    return BackendApiClient.requestAsync({
      baseURL: import.meta.env.VITE_STOREFRONT_API_BASE_URL,
      method: 'GET',
      url: `/stores/${this.getStorefrontDomain()}`,
    });
  };

  public getPage = async (page: string): Promise<DataWrappedResponse<IPage>> => {
    return BackendApiClient.requestAsync({
      baseURL: this.BASE_URL,
      method: 'GET',
      url: `/api/pages${page}`,
    });
  };

  private isStorefront = (): boolean => {
    return !!getStorefrontOrigin() && DomainResource.getHostname() !== 'localhost';
  };

  private getStorefrontDomain = (): string => {
    return getHostname(import.meta.env.VITE_STOREFRONT_ORIGIN);
  };
}

export default new StorefrontManager();
